import React, { Component } from 'react';
import { Title } from '../layout';
import { TabsComponent } from '../common';
import { CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';
import { UnregisteredParticipantsComponent } from './unregistered';
import { RegisteredParticipantsComponent } from './registered';
import './participants.scss';

const ageRestrictionNotification =
  "Children under the age of 13 may not enter any personal information directly into the system. " +
  "Such information should be collected by an adult with your organization and who may then enter the information.";


export class ParticipantsComponent extends Component {

  render() {

    const routes = [
      {
        url: '/',
        path: '/',
        exact: true,
        label: 'REGISTERED PARTICIPANTS',
        component: RegisteredParticipantsComponent,
      },
      {
        url: '/unregistered',
        path: '/unregistered',
        label: 'UNREGISTERED PARTICIPANTS',
        component: UnregisteredParticipantsComponent,
      }
    ];

    return (
      <div>
        <Title title="Participant Accounts"/>
        <br/>
        <TabsComponent id="participant-types" routes={routes}/>
        <div className="participants-message-wrapper">
          <CustomIcon
            iconChoice={CustomIconSet.ic_disclaim_msg_14x14}
            css={{
              ssgCustomIconContainer: 'ssg-custom-icon-container participants-message-icon',
            }}/>
          <p className="ssg-forms-text normal participants-message-text">{ageRestrictionNotification}</p>
        </div>
      </div>
    );
  }
}

ParticipantsComponent.propTypes = {
};

export default ParticipantsComponent;
